import { validate } from './validations'
import { build } from '../../services/crudFactory'
import { Action } from '../../services/actions.factory'
import { messageActions } from '../../store/message/index'
import { actions as tipoSepulturaActions } from '../tipoSepultura/tipoSepultura.actions'
import apiService from '../../services/api.service'
import utils from '../../utils'
import _ from 'lodash'
import apiServiceIdValue from '../../services/api-id-value-service'

const BASE_PATH = '/lottustech/remessafinanceira'
const crud = build(validate, BASE_PATH)
const prefix = 'crudControleFinanceiro'

const newTypes = {
  SET_BOOLEAN_FILTER: `${prefix}setBooleanFilter`,
  SET_LOOKUP_CONFIGURACAO_BOLETO_VISIBLE: `${prefix}setLookupConfiguracaoBoletoVisible`,
  SET_LOOKUP_TIPO_SEPULTURA_VISIBLE: `${prefix}setLookupTipoSepulturaVisible`,
  SET_LOOKUP_TAXA_VISIBLE: `${prefix}setLookupTaxaVisible`,
  SET_CONFIGURACAO_BOLETO: `${prefix}setConfiguracaoBoleto`,
  SET_DATA_VENCIMENTO: `${prefix}setDataVencimento`,
  SHOW_ERROS: `${prefix}showErros`,
  SET_ADVANCED_FILTER: `${prefix}setAdvancedFilter`,
  FILTER: `${prefix}filter`,
  UNMOUNT: `${prefix}unmount`,
  RESET: `${prefix}reset`,
  SET_CONTA_CORRENTE: `${prefix}setContaCorrente`,
}

const actions = new Action(prefix, crud)
const types = Object.assign({}, actions.types, newTypes)

actions.reset = () => {
  return {
    type: types.RESET,
  }
}

actions.unmount = () => {
  return {
    type: types.UNMOUNT,
  }
}

actions.setBooleanFilter = (field, value) => {
  return {
    type: types.SET_BOOLEAN_FILTER,
    field,
    value,
  }
}

actions.setLookupTaxaVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_TAXA_VISIBLE,
    visible,
  }
}

actions.setLookupTipoSepulturaVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_TIPO_SEPULTURA_VISIBLE,
    visible,
  }
}

actions.setLookupConfiguracaoBoletoVisible = (visible) => {
  return {
    type: types.SET_LOOKUP_CONFIGURACAO_BOLETO_VISIBLE,
    visible,
  }
}

actions.setConfiguracaoBoleto = (payload) => {
  return {
    type: types.SET_CONFIGURACAO_BOLETO,
    payload,
  }
}

actions.setContaCorrente = (payload) => {
  return {
    type: types.SET_CONTA_CORRENTE,
    payload,
  }
}

actions.setDataVencimento = (payload) => {
  return {
    type: types.SET_DATA_VENCIMENTO,
    payload,
  }
}

actions.showErros = (payload) => {
  return {
    type: types.SHOW_ERROS,
    payload,
  }
}

actions.setAdvancedFilter = (field, value, hash) => {
  return {
    type: types.SET_ADVANCED_FILTER,
    field,
    value,
    hash,
  }
}

actions.loadTiposSepulturas = (oidUnidade) => {
  return (dispatch, getState) => {
    const params = {
      filters: [{ campo: 'unidade', valor: oidUnidade, tipoFiltro: 'IGUAL_A' }],
      index: 0,
      max: 100,
      projectionFields: ['oid', 'descricao'],
    }
    apiService.post(`/lottustech/tipossepultura/all`, params).then((response) => {
      dispatch(tipoSepulturaActions.setRecords(response.data.records))
    })
  }
}

actions.gerarBoletos = () => {
  return (dispatch, getState) => {
    const state = getState()[`crudLoteBoletosState`]
    const record = state.currentRecord
    const param = {
      oidConfiguracao: record.configuracaoBoleto.id,
      mesVencimento: record.vencimento,
      oidUnidade: record.unidade && record.unidade.id ? record.unidade.id : null,
      oidTaxa: record.taxa && record.taxa.id ? record.taxa.id : null,
      oidContrato: record.contrato && record.contrato.id ? record.contrato.id : null,
      periodoInicial: record.periodoInicial,
      periodoFinal: record.periodoFinal,
    }
    const path = `/lottustech/ailos/gerar/boleto/lote`
    return apiService
      .post(path, param)
      .then((response) => {
        dispatch(actions.showErros(response.data))
      })
      .catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })
  }
}

actions.loadConfiguracaoBoletoPadrao = (oid) => {
  return (dispatch, getState) => {
    const path = `/lottustech/configuracoesBoletos/${oid}`
    return apiService.get(path).then((response) => {
      dispatch(actions.setConfiguracaoBoleto(response.data))
    })
  }
}

actions.loadContasCorrentes = () => {
  return (dispatch, getState) => {
    apiServiceIdValue
      .getContasCorrentes()
      .then((response) => {
        const data = _.get(response, 'data', [])
        dispatch(actions.setContaCorrente(data))
      })
      .catch((err) => {
        if (err.response) {
          const messages = err.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        }
      })
  }
}

const makeMessages = (messages, type) => {
  let sticky = false
  let summary = 'Sucesso!'
  if (type === 'error') {
    summary = 'Erro!'
    sticky = true
  }
  return messages.map((message) => {
    return { sticky: sticky, summary: summary, severity: type, detail: message }
  })
}

actions.filter = (path) => {
  return (dispatch, getState) => {
    const messages = 'Filtro de taxa é obrigatório'
    const state = getState()[`crudControleFinanceiroState`]
    const selectedFilters = state.selectedFilters
    if (selectedFilters) {
      if (state.columns.findIndex((c) => c.field === 'oidContrato') < 0) {
        const columns = state.columns
        columns.push({
          field: 'oidContrato',
          columnKey: 'oidContrato',
          sortable: true,
          filter: true,
          columnSortField: 'oidContrato',
          visible: true,
        })
        dispatch(actions.setColumns(columns))
      }

      dispatch(actions.executeFilter(path))
    } else {
      dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
    }
  }
}

actions.loadConfiguracaoBoletoPadrao = (oid) => {
  return (dispatch, getState) => {
    const path = `/lottustech/configuracoesBoletos/${oid}`
    return apiService.get(path).then((response) => {
      dispatch(actions.setConfiguracaoBoleto(response.data))
    })
  }
}

actions.gerarLancamentos = (filtros, filtroUnidade) => {
  return (dispatch, getState) => {
    const state = getState()[`crudControleFinanceiroState`]
    const selectedRecords = state.selectedRecords
    const currentRecord = state.currentRecord
    let taxas = []
    if (utils.isArrayNotEmpty(currentRecord.taxas)) {
      taxas = currentRecord.taxas.map((e) => e.id)
    }
    const oidUnidade = filtroUnidade && parseInt(filtroUnidade.id) ? parseInt(filtroUnidade.id) : null
    if (utils.isArrayNotEmpty(selectedRecords)) {
      let baseParams = []
      if (!filtros.selecionarTodos) {
        selectedRecords.forEach((e) => {
          const baseParam = {
            oidContrato: e.oidContrato,
            oidResponsavel: e.oidResponsavel,
            oidLancamentoFinanceiro: e.oidLancamentoFinanceiro,
            oidUnidade: e.oidUnidade,
          }
          baseParams.push(baseParam)
        })
      }
      const params = {
        oidUnidade,
        vencimento: currentRecord.vencimento,
        oidConfiguracaoBoleto: currentRecord.configuracaoBoleto.id,
        taxas: taxas,
        baseParams: baseParams,
        pagarConspagaAte: currentRecord.conspagaPagarAte,
        incluirContratosComParcelamento: !!currentRecord.incluirContratosComParcelamento,
        gerarBoletosIndividual: currentRecord.gerarBoletosIndividual,
        selecionarTodos: filtros.selecionarTodos,
        filtrosPesquisa: filtros.filtrosPesquisa,
        filtroContratos: filtros.filtroContratos,
        // Critério personalizado (PHOENIX-943). Campo tipado, e não o pseudo-filtro que vai em
        // filtrosPesquisa: o back só lê param.getOidCriterio() na geração.
        // ATENÇÃO: esta ação não tem gatilho na tela hoje (o container expõe gerarLancamentos, mas
        // nenhum JSX o chama) e o params daqui nem monta tipoFormaPagamento, então o endpoint
        // responderia 400. O caminho vivo é gerarBoletos -> /gerarRemessa, logo abaixo. Mantido por
        // consistência; não homologar por aqui.
        oidCriterio: filtros.oidCriterio,
        competencia: currentRecord.competencia,
      }
      const path = `${BASE_PATH}/gerarLancamentos`
      return apiService
        .post(path, params)
        .then((response) => {
          dispatch(actions.clearSelectedRecords())
          dispatch(messageActions.messageShowMessages(makeMessages(['Lançamentos gerados com sucesso!'], 'success')))
        })
        .catch((err) => {
          const messages = err.response.data
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        })
    }
  }
}

actions.gerarBoletos = (filtros, filtroUnidade) => {
  return (dispatch, getState) => {
    const state = getState()[`crudControleFinanceiroState`]
    const selectedRecords = state.selectedRecords
    const currentRecord = state.currentRecord
    let taxas = []
    if (utils.isArrayNotEmpty(currentRecord.taxas)) {
      taxas = currentRecord.taxas.map((e) => e.id)
    }
    const oidUnidade = filtroUnidade && parseInt(filtroUnidade.id) ? parseInt(filtroUnidade.id) : null

    if (utils.isArrayNotEmpty(selectedRecords)) {
      let baseParams = []
      if (!filtros.selecionarTodos) {
        selectedRecords.forEach((e) => {
          const baseParam = {
            oidContrato: e.oidContrato,
            oidResponsavel: e.oidResponsavel,
            oidLancamentoFinanceiro: e.oidLancamentoFinanceiro,
            oidUnidade: e.oidUnidade,
          }
          baseParams.push(baseParam)
        })
      }
      const params = {
        oidUnidade,
        vencimento: currentRecord.vencimento,
        parcelas: currentRecord.parcelas,
        oidConfiguracaoBoleto: _.get(currentRecord, 'configuracaoBoleto.id', null),
        oidContaCorrente: _.get(currentRecord, 'contaCorrente.id', null),
        taxas: taxas,
        baseParams: baseParams,
        pagarConspagaAte: currentRecord.conspagaPagarAte,
        selecionarTodos: filtros.selecionarTodos,
        filtrosPesquisa: filtros.filtrosPesquisa,
        filtroContratos: filtros.filtroContratos,
        gerarBoletosIndividual: currentRecord.gerarBoletosIndividual,
        incluirContratosComParcelamento: !!currentRecord.incluirContratosComParcelamento,
        tipoFormaPagamento: currentRecord.tipoFormaPagamento,
        competencia: currentRecord.competencia,
        // gerarRemessa chega em gerarLancamentos por dentro (gerarBoletos -> gerarRemessaBoletos),
        // então o critério vale aqui pelo mesmo motivo do gerarLancamentos.
        oidCriterio: filtros.oidCriterio,
        gerarMensagemPersonalizada: filtros.gerarMensagemPersonalizada,
        codigoFlash: filtros.codigoFlash,
        tituloRemessa: filtros.tituloRemessa,
        mensagemPersonalizada: filtros.mensagemPersonalizada
      }

      const message =
        "Solicitação enviada. Esse processo leva alguns minutos. Consulte o resultado na tela de 'Consulta de Remessas'."
      dispatch(messageActions.messageShowMessages(makeMessages([message], 'warn')))

      const path = `${BASE_PATH}/gerarRemessa`
      apiService.post(path, params).catch((err) => {
        const messages = err.response.data
        dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
      })

      setTimeout(() => {
        dispatch(actions.clearSelectedFilters())
        dispatch(actions.clearSelectedRecords())
        dispatch(actions.unmount())
      }, 1000)
    }
  }
}

actions.agendarRemessa = (dataBaseExecucao, repetirExecucaoMensalmente, filtros, filtroUnidade) => {
  return (dispatch, getState) => {
    const state = getState()[`crudControleFinanceiroState`]
    const selectedRecords = state.selectedRecords
    const currentRecord = state.currentRecord
    let taxas = []
    if (utils.isArrayNotEmpty(currentRecord.taxas)) {
      taxas = currentRecord.taxas.map((e) => e.id)
    }
    const oidUnidade = filtroUnidade && parseInt(filtroUnidade.id) ? parseInt(filtroUnidade.id) : null

    if (utils.isArrayNotEmpty(selectedRecords)) {
      const params = {
        oidUnidade,
        vencimento: currentRecord.vencimento,
        parcelas: currentRecord.parcelas,
        oidConfiguracaoBoleto: _.get(currentRecord, 'configuracaoBoleto.id', null),
        oidContaCorrente: _.get(currentRecord, 'contaCorrente.id', null),
        taxas: taxas,
        pagarConspagaAte: currentRecord.conspagaPagarAte,
        selecionarTodos: filtros.selecionarTodos,
        filtrosPesquisa: filtros.filtrosPesquisa,
        filtroContratos: filtros.filtroContratos,
        gerarBoletosIndividual: currentRecord.gerarBoletosIndividual,
        incluirContratosComParcelamento: !!currentRecord.incluirContratosComParcelamento,
        tipoFormaPagamento: currentRecord.tipoFormaPagamento,
        competencia: currentRecord.competencia,
        // Sem isto o JSON do agendamento saía com "oidCriterio": null e o job rodava sem critério,
        // em silêncio — AgendamentoUtils grava a chave justamente porque o pseudo-filtro da grid é
        // descartado pela whitelist de coverterFiltros e não sobrevive ao agendamento.
        oidCriterio: filtros.oidCriterio,
        gerarMensagemPersonalizada: filtros.gerarMensagemPersonalizada,
        codigoFlash: filtros.codigoFlash,
        tituloRemessa: filtros.tituloRemessa,
        mensagemPersonalizada: filtros.mensagemPersonalizada
      }

      const path = `/lottustech/agendamentos/criarAgendamentoRemessa`

      const body = {
        dataBaseExecucao,
        repetirExecucaoMensalmente,
        params
      }

      return apiService
        .post(path, body)
        .then(() => {
          dispatch(messageActions.messageShowMessages(makeMessages(['Agendamento de remessa criado com sucesso'], 'success')))
          // A limpeza só acontece quando o agendamento foi criado. Fora da promise ela rodava
          // também no erro, e o operador perdia os filtros que tinha montado sem saber por quê.
          setTimeout(() => {
            dispatch(actions.clearSelectedFilters())
            dispatch(actions.clearSelectedRecords())
            dispatch(actions.unmount())
          }, 1000)
        })
        .catch((err) => {
          // O back devolve a causa no corpo do 400; mostrar texto fixo escondia o motivo da falha
          // do operador e do suporte. Mesmo tratamento de gerarLancamentos, logo acima, mas com
          // checagem de tipo: em 502/504 o corpo vem como página HTML do proxy, e objeto dentro do
          // detail estoura o Messages do PrimeReact ("Objects are not valid as a React child").
          const corpo = _.get(err, 'response.data')
          const texto = typeof corpo === 'string' ? corpo.trim() : ''
          // Página HTML de proxy (502/504) não é mensagem: cairia inteira num toast sticky.
          const util = texto && !texto.startsWith('<') ? texto : ''
          const messages = util || 'Não foi possível criar o agendamento'
          dispatch(messageActions.messageShowMessages(makeMessages([messages], 'error')))
        })
    }
  }
}

actions.setConfiguracaoBoleto = (payload) => {
  return {
    type: types.SET_CONFIGURACAO_BOLETO,
    payload,
  }
}

export { types, actions }
